import { Roboto_Condensed } from 'next/font/google'

const RobotoCondensedFont = Roboto_Condensed({
	variable: '--font-roboto-condensed',
	weight: ['300', '400', '500', '700'],
	display: 'swap',
	style: 'normal',
	subsets: ['latin']
})

export default RobotoCondensedFont
